<template>
  <b-modal
    title="Update My Account"
    ref="my-info-modal"
    id="my-info-modal"
    size="lg"
    ok-title="Update"
    @show="resetModal"
    @hidden="resetModal"
    @ok="updateUser"
  >
    <b-tabs>
      <b-tab title="User Information" @click="changeTab(0)">
        <b-card class="m-0">
          <span class="font-weight-bold">Email</span>
          <b-form-input
            id="user-email"
            v-model="userData.username"
            class="border-0 bg-transparent"
            disabled
          />
          <form ref="nameForm" @submit.stop.prevent="updateInfo">
            <b-form-group
              :state="nameState"
              invalid-feedback="Name is required"
            >
              Name <span class="text-danger">*</span>
              <b-form-input
                v-model="userData.name"
                id="user-name"
                maxLength="50"
                required
                :state="nameState"
              />
            </b-form-group>
          </form>
        </b-card>
      </b-tab>
      <b-tab title="Change Password" @click="changeTab(1)">
        <b-card class="m-0">
          <form ref="passwordForm" @submit.stop.prevent="updatePassword">
            <b-form-group
              :state="currentPasswordState"
              invalid-feedback="Current Password is required"
            >
              Current Password <span class="text-danger">*</span>
              <b-form-input
                v-model="current_pwd"
                id="current-password"
                type="password"
                required
                :state="currentPasswordState"
              />
            </b-form-group>
            <b-form-group
              :state="newPasswordState"
              :invalid-feedback="feedbackMessage"
            >
              New Password <span class="text-danger">*</span>
              <b-form-input
                v-model="new_pwd"
                id="new-password"
                type="password"
                :state="newPasswordState"
                required
              />
            </b-form-group>
            <b-form-group
              :state="confirmPasswordState"
              :invalid-feedback="feedbackMessage"
            >
              Confirm New Password <span class="text-danger">*</span>
              <b-form-input
                v-model="confirm_new_pwd"
                id="confirm-new-password"
                type="password"
                :state="confirmPasswordState"
                required
              />
            </b-form-group>
          </form>
        </b-card>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { BTabs, BTab, BCard, BFormGroup, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";
import useJwt from "@/auth/jwt/useJwt";

import AuthenticationService from "@/services/authentication.service";
import UserService from "@/services/user.service";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "MyInfo",
  components: {
    BTabs,
    BTab,
    BCard,
    BFormGroup,
    BFormInput,
    vSelect,
  },
  data() {
    return {
      userData: {},
      current_pwd: "",
      new_pwd: "",
      confirm_new_pwd: "",
      nameState: null,

      currentPasswordState: null,
      newPasswordState: null,
      confirmPasswordState: null,
      feedbackMessage: "New Password is required",
      tabIndex: 0,
    };
  },
  methods: {
    logout() {
      console.log('-- log out --')
      useJwt.logout();

      // Redirect to login page
      this.$router.push({ name: 'login' })
    },
    resetModal() {
      const user = useJwt.getUserData();

      this.userData = {
        id: user.id,
        name: user.name,
        roleId: user.role.id,
        username: user.username,
      };
      this.current_pwd = "";
      this.new_pwd = "";
      this.confirm_new_pwd = "";

      this.nameState = null;
      this.currentPasswordState = null;
      this.newPasswordState = null;
      this.confirmPasswordState = null;
    },
    validateCheckForm() {
      const valid = this.$refs.nameForm.checkValidity();
      this.nameState = valid;
      return valid;
    },
    validatePasswordForm() {
      const valid = this.$refs.passwordForm.checkValidity();
      this.currentPasswordState = this.current_pwd === "" ? valid : null;
      this.newPasswordState = this.new_pwd === "" ? valid : null;
      this.confirmPasswordState = this.confirm_new_pwd === "" ? valid : null;
      this.feedbackMessage = "New Password is required";
      if (valid && this.new_pwd !== this.confirm_new_pwd) {
        this.newPasswordState = false;
        this.confirmPasswordState = false;
        this.feedbackMessage = "Passwords are not same";
        return false;
      } else if (valid && this.current_pwd === this.confirm_new_pwd) {
        this.newPasswordState = false;
        this.confirmPasswordState = false;
        this.feedbackMessage = "Same as your current password";
        return false;
      }
      return valid;
    },
    updateUser(e) {
      e.preventDefault();
      if (this.tabIndex === 0) {
        this.updateInfo();
      } else {
        this.updatePassword();
      }
    },
    updateInfo() {
      if (!this.validateCheckForm() && this.tabIndex === 0) return;
      this.updateUserData("info");
    },
    updatePassword() {
      if (!this.validatePasswordForm() && this.tabIndex === 1) return;
      this.updateUserData("password");
    },
    changeTab(index) {
      this.tabIndex = index;
    },
    updateUserData(mode) {
      const swalText = mode === "info" ? "User Info" : "Password";
      this.$swal({
        title: "Are you sure?",
        html: `You want to update the ${swalText}!<br>&nbsp;`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        padding: "1rem",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response =
            mode === "info"
              ? await UserService.update(this.userData)
              : await UserService.changePassword({
                  password: this.current_pwd,
                  newPassword: this.new_pwd,
                });
          if (response && response.status === 200) {
            const meResponse = await AuthenticationService.me(useJwt.getToken());
            useJwt.setLoginInfo(meResponse.data.data);
            this.$root.$emit("set-login-info");

            this.$bvModal.hide("my-info-modal");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Successfully updated ${swalText}!
                Please Log-in again.`,
                icon: "EditIcon",
                variant: "success",
              },
            });

            this.logout()


          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }

        }
      });
    },
  },
  created() {
    this.resetModal();
  },
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}

</style>